<!-- Flight Map Container -->
<div class="flight-map-container" [style.height]="height">
  <!-- Google Map -->
  <google-map
    #googleMapRef
    [zoom]="zoom"
    [center]="center"
    [options]="mapOptions"
    width="100%"
    [height]="height"
    (mapInitialized)="onMapReady()"
    (tilesloaded)="onTilesLoaded()">

    <!-- Flight Path Polylines and Markers (using cached data) -->
    <ng-container *ngFor="let cached of cachedPaths; trackBy: trackByPathId">
      <map-polyline
        [path]="cached.polylinePath"
        [options]="cached.polylineOptions">
      </map-polyline>

      <!-- Start Marker -->
      <map-marker
        #startMarker="mapMarker"
        *ngIf="cached.startPosition"
        [position]="cached.startPosition"
        [options]="cached.startMarkerOptions"
        (mapClick)="showPathInfo(cached.path, startMarker)">
      </map-marker>

      <!-- End Marker -->
      <map-marker
        *ngIf="cached.endPosition"
        [position]="cached.endPosition"
        [options]="cached.endMarkerOptions">
      </map-marker>
    </ng-container>

    <!-- Info Window -->
    <map-info-window>
      <div class="info-window" *ngIf="selectedPath">
        <h6 class="mb-1">{{ selectedPath.name }}</h6>
        <div class="small text-muted mb-2">{{ selectedPath.fileName }}</div>
        <div class="d-flex gap-3 small">
          <div>
            <strong>Area:</strong> {{ selectedPath.areaAcres | number:'1.1-1' }} ac
          </div>
          <div>
            <strong>Points:</strong> {{ selectedPath.coordinates.length }}
          </div>
        </div>
        <div class="small text-muted mt-1">
          Uploaded: {{ formatDate(selectedPath.uploadedAt) }}
        </div>
      </div>
    </map-info-window>
  </google-map>

  <!-- Upload Overlay -->
  <div *ngIf="showUploadOverlay"
       class="upload-overlay"
       [class.dragging]="isDragging"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">

    <div class="upload-content">
      <!-- Processing State -->
      <ng-container *ngIf="isProcessing">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Processing...</span>
        </div>
        <h5>Processing File...</h5>
        <p class="text-muted mb-0">Extracting flight path data</p>
      </ng-container>

      <!-- Default State -->
      <ng-container *ngIf="!isProcessing">
        <div class="upload-icon mb-3">
          <i class="bi bi-cloud-upload"></i>
        </div>
        <h5>Upload Flight Path</h5>
        <p class="text-muted mb-3">Drag & drop a KML or ZIP file here</p>

        <div class="d-flex gap-2 justify-content-center">
          <label class="btn btn-primary">
            <i class="bi bi-folder2-open me-2"></i>Browse Files
            <input type="file"
                   class="d-none"
                   accept=".kml, .zip"
                   (change)="onFileSelected($event)">
          </label>
          <button type="button" class="btn btn-outline-secondary" (click)="cancelUpload()">
            Cancel
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="uploadError" class="alert alert-danger mt-3 mb-0 py-2">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ uploadError }}
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Map Legend (when showing multiple paths) -->
  <div *ngIf="cachedPaths.length > 1 && !showUploadOverlay" class="map-legend">
    <div class="legend-title">Flight Paths</div>
    <div *ngFor="let cached of cachedPaths; let i = index; trackBy: trackByPathId" class="legend-item">
      <span class="legend-color" [style.background-color]="pathColors[i % pathColors.length]"></span>
      <span class="legend-label text-truncate" [title]="cached.path.name">{{ cached.path.name }}</span>
      <span class="legend-value">{{ cached.path.areaAcres | number:'1.1-1' }} ac</span>
    </div>
  </div>

  <!-- Map Controls -->
  <div *ngIf="!showUploadOverlay && cachedPaths.length > 0" class="map-controls">
    <button type="button"
            class="btn btn-sm btn-light"
            (click)="fitBounds()"
            title="Fit to bounds">
      <i class="bi bi-arrows-fullscreen"></i>
    </button>
  </div>
</div>
